import React from "react";
import * as W from "../../pages/Word/VoiceRecord/VoiceRecord.style";

const Recall = () => {
  return (
    <>
      <W.VoiceRecordTitle>추억을 돌이켜보아요</W.VoiceRecordTitle>
    </>
  );
};

export default Recall;
